<template>
  <div>
    <!-- <p>Aantal vacatures: {{$store.getters.filteredJobs.length}}/{{$store.state.allJobs.length}}</p> -->
    <label class="mr-sm-2" for="sortByInput">Sortering:</label>
    <b-form-select
      id="sortByInput"
      class
      :value="null"
      v-model="sortBy"
      :options="$store.state.sortOptions"
    ></b-form-select>
  </div>
</template>

<script>
export default {
  computed: {
    sortBy: {
      get() {
        if (this.$store.state.sortBy == "") {
          this.$store.commit("mutateSortBy", this.$store.state.sortOptions[0]);
        }
        return this.$store.state.sortBy;
      },
      set(value) {
        this.$store.commit("mutateSortBy", value);
      }
    }
  },
  name: "SortBar",
};
</script>

<style scoped>
.sortByContainer {
  float: right;
}
</style>